import React, { useRef } from "react";
import { CircleOff } from "lucide-react";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function SupportStatusModal({
  handleStatus = () => {},
  tooltip = false,
  name = 'Conversation',
  activeModal = false,
  setActiveModal = () => {},
  previousScrollPosition = 0,
  setPreviousScrollPosition = () => {},
}) {
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal} onClose={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn"
          onClick={() => {
            setActiveModal(true);
            setPreviousScrollPosition(window.scrollY);
            window.scrollTo(0, 0);
          }}
        >
          <CircleOff width={20} height={20} />
          {tooltip &&
            <span className="docpro_tip">Close</span>
          }
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Delete Record</Drawer.Title>
            <Drawer.Description className="sr-only">Delete a recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_deleteboxbox">
                  <div className="docpro_iconbox_icon docpro_badge_red">
                    <CircleOff width={50} height={50} />
                  </div>
                  <Spacing lg="20" sm="20" />
                  <div className="docpro_iconbox_right">
                    <h3 className="docpro_fs_20">Are you Sure?</h3>
                    {name !== '' ?
                      <p className="docpro_mb_0 docpro_fs_16">
                        You want to close <span className="docpro_red_color font-semibold">{name}</span>?<br /> This action cannot be undone.
                      </p>
                    :
                      <p className="docpro_mb_0 docpro_fs_16">
                        You want to close this record?<br /> This action cannot be undone.
                      </p>
                    }
                    <Spacing lg="32" sm="32" />
                    <div className="docpro_modal_btns">
                      <button
                        type="button"
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={() => {
                          handleDrawerClose();
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn docpro_btn_red  size_lg"
                        onClick={() => {
                          handleStatus();
                          handleDrawerClose();
                        }}
                      >
                        Yes, Closed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
